import axios from "../../../../../../api/axiosInstance";

export const deleteProductStoreCategory = async (id: string): Promise<void> => {
  await axios.delete(`/api/private/product-store/categories/${id}`);
};
